import '../css/about.css';
import 'overlayscrollbars/overlayscrollbars.css';
import { OverlayScrollbars } from 'overlayscrollbars';

export default class About {
	constructor() {
		this.container = document.getElementById('about');
		this.wrapper = document.getElementById('about-wrapper');
	}

	init() {
		const openBtn = document.getElementById('about-btn');
		const closeBtn = document.getElementById('about-close-btn');
		if (!openBtn || !closeBtn) return;
		openBtn.onclick = () => {
			this.container?.classList.add('active');
		};

		closeBtn.onclick = () => {
			this.container?.classList.remove('active');
			if (this.wrapper) this.wrapper.dataset.state = 'utmutato';
			const { viewport } = this.scrollbar?.elements();
			viewport?.scrollTo({ top: 0 });
		};

		this.container.onclick = (event) => {
			if (event.target.id === this.container.id) {
				this.container?.classList.remove('active');
				if (this.wrapper) this.wrapper.dataset.state = 'utmutato';
				const { viewport } = this.scrollbar?.elements();
				viewport?.scrollTo({ top: 0 });
			}
		};

		this.setupNav();

		setTimeout(() => {
			this.scrollbar = OverlayScrollbars(document.querySelector('#about-sections'), {
				overflow: {
					x: 'hidden',
					y: 'scroll'
				}
			});
		});
	}

	setupNav() {
		const navElements = document.querySelectorAll('.about-nav-element');
		for (const navElement of navElements) {
			navElement.onclick = () => {
				if (!this.wrapper) return;
				const value = navElement.dataset.value || '';
				if (!value) return;
				this.wrapper.dataset.state = value;
				const { viewport } = this.scrollbar?.elements();
				viewport?.scrollTo({ top: 0 });
			};
		}
	}
}
